var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.75C18.8353 12.75 19.164 12.7787 19.4836 12.8338C19.8173 11.9529 20 10.9978 20 10C20 9.62985 19.4452 9.56867 19.2538 9.88548C18.3432 11.3925 16.6892 12.4 14.8 12.4C11.9281 12.4 9.6 10.0719 9.6 7.2C9.6 5.31077 10.6075 3.65685 12.1145 2.74621C12.4313 2.55478 12.3702 2 12 2C7.58172 2 4 5.58172 4 10C4 10.9662 4.1713 11.8925 4.48519 12.75H18.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.25H4C3.58579 14.25 3.25 14.5858 3.25 15C3.25 15.4142 3.58579 15.75 4 15.75H19.25C19.6642 15.75 20 15.4142 20 15C20 14.5858 19.6642 14.25 19.25 14.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17.25H7C6.58579 17.25 6.25 17.5858 6.25 18C6.25 18.4142 6.58579 18.75 7 18.75H16.25C16.6642 18.75 17 18.4142 17 18C17 17.5858 16.6642 17.25 16.25 17.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20.5H13.75C14.1642 20.5 14.5 20.8358 14.5 21.25C14.5 21.6642 14.1642 22 13.75 22H9.5C9.08579 22 8.75 21.6642 8.75 21.25C8.75 20.8358 9.08579 20.5 9.5 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonAlt);
export default __webpack_public_path__ + "static/media/moon-alt.ea57f5a2a9beb96696bf7d67697ff658.svg";
export { ForwardRef as ReactComponent };